$scroll-to-top-border-width: 2px;

:host {
  z-index: $zindex-scroll-to-top;
  display: none;
}

.scroll-to-top {
  border: $scroll-to-top-border-width solid $color-int-blue;
  border-radius: 50%;
  background-color: rgba($color-white, 0.8);
  color: $color-int-blue;
  height: $baseline-6;
  width: $baseline-6;
  padding: $baseline - $scroll-to-top-border-width;
  outline: none;
  cursor: pointer;

  @include active-hover {
    border-color: $color-int-blue--active;
    color: $color-int-blue--active;
  }

  &:active {
    transform: scale(0.98);
  }
}

.sdx--dark-theme {
  .scroll-to-top {
    background-color: rgba($color-dusk-tint-2-dark-theme, 0.8);
    color: $color-int-blue-dark-theme;

    @include active-hover {
      border-color: $color-int-blue-dark-theme--active;
      color: $color-int-blue-dark-theme--active;
    }
  }
}
